export default __webpack_public_path__ + "static/media/icon-arrow-down-white.d31af770.svg";